import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button } from "..";
import { useFetchItems, useHardCode, useTextColorDynamic } from "../../hooks";
import { useAppContext } from "../../contexts";
import "./form.css";

export const Form = () => {
  const {
    baseURL,
    isAutoFill,
    isBtnDisabled,
    setIsBtnDisabled,
    setRazorPayPaymentSuccess,
    setIsPaymentCompleted,
  } = useAppContext();
  const [autoOrderId, setAutoOrderID] = useState("");
  const [autoCID, setAutoCID] = useState("");
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const isPureFemale = SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const { isLoader, orderFetch, isError, errorMsg, formData, setFormData } =
    useFetchItems();
  const { getContrast } = useTextColorDynamic();
  const powered_by = isPureFemale
    ? PURE_FEMALE_TRANSLATION.form.powered_by
    : "Powered by";

  const storeConfigState = useSelector((state) => state.storeSettings);

  const formDataHandler = (e, orderId) => {
    const checkTestOrder = (tid) => {
      let formOrderID = e?.target?.value || orderId;
      return tid?.toLowerCase() === formOrderID?.toLowerCase();
    };
    let value, isTestOrder;
    if (orderId) {
      isTestOrder = storeConfigState?.testOrder.find(checkTestOrder);
      value = isTestOrder ? orderId.toUpperCase() : orderId;
    } else {
      isTestOrder = storeConfigState?.testOrder?.find(checkTestOrder);
      value = isTestOrder
        ? e?.target?.value?.toUpperCase()
        : e?.target?.value;
    }

    setFormData({ ...formData, orderNo: value });
  };

  const buttonHandler = (e) => {
    e.preventDefault();

    const value = e?.target?.value;

    orderFetch(value, e);
  };

  useEffect(() => {
    if (baseURL) {
      if (formData?.orderNo && formData?.emailPhoneZipCode) {
        setIsBtnDisabled(false);
      } else {
        setIsBtnDisabled(true);
      }
    }
    const bodyStyles = document.body.style;
    if (storeConfigState?.themeConfigOthers?.primary_color === "") {
      bodyStyles.setProperty("--brand-color", "#251960");
    } else {
      const isContrast = getContrast(
        storeConfigState?.themeConfigOthers?.primary_color
      );

      if (isContrast === "black") {
        bodyStyles.setProperty("--brand-white", "#000000"); /*set black*/
      } else if (isContrast === "white") {
        bodyStyles.setProperty("--brand-white", "#ffffff"); /*set white*/
      }
      bodyStyles.setProperty(
        "--brand-color",
        storeConfigState?.themeConfigOthers?.primary_color
      );
      setRazorPayPaymentSuccess(false);
      setIsPaymentCompleted(false);
    }
  }, [formData.orderNo, formData.emailPhoneZipCode, baseURL]);

  useEffect(() => {
    if (isAutoFill) {
      formDataHandler(false, storeConfigState.autoOrderId);
      setAutoCID(storeConfigState.autoCID);
      setAutoOrderID(storeConfigState.autoOrderId);
      setIsBtnDisabled(false);
      orderFetch(
        false,
        false,
        storeConfigState.autoOrderId,
        storeConfigState.autoCID
      );
    }
  }, [isAutoFill]);
  return (
    <form action="" className="main__form form">
      <h2 className="form__title">
        <span className="form__span">
          {`${storeConfigState?.themeConfig?.landing_page_card_title}`}
        </span>
      </h2>
      <label className="form__label">
        <input
          type=""
          className="form__inp form__order"
          placeholder={`${storeConfigState?.themeConfig?.landing_page_order_no_input_label}`}
          name="orderNo"
          defaultValue={autoOrderId}
          onChange={(e) => {
            formDataHandler(e);
          }}
          required
        />
        <div className="tooltip_custom">
          <img src="assets/svg/info.svg" className="form__info" alt="tooltip" />
          <span className="tooltiptext_custom">
            {`${storeConfigState?.themeConfig?.landing_page_order_no_input_hover}`}{" "}
          </span>
        </div>
      </label>
      <label className="form__label">
        <input
          type=""
          className="form__inp form__auth"
          placeholder={`${storeConfigState?.themeConfig?.landing_page_email_id_input_label}`}
          name="emailPhoneZipCode"
          defaultValue={autoCID}
          onChange={(e) => {
            setFormData({ ...formData, [e.target.name]: e.target.value });
          }}
          required
        />
      </label>
      <span className="errorMsg">
        {isError &&
          `${
            storeConfigState?.themeConfig?.[
              errorMsg.toLowerCase().replace(/[0-9]/g, "")
            ]
          } ${formData?.orderNo}`}
      </span>
      <Button
        name={
          isLoader ? (
            <div
              className=" saara-spinner-border saara-spinner-border-sm"
              role="status"
            >
              <span className="saara-visually-hidden"></span>
            </div>
          ) : (
            `${storeConfigState?.themeConfig?.landing_page_card_button_label}`
          )
        }
        onClick={(e) => {
          buttonHandler(e);
        }}
        disabled={isBtnDisabled}
      />
      {storeConfigState.isChatGPTEnabled && (
        <div
          className="saara-chatgpt-widget-link"
          id="saara-chatgpt-widget-link-id"
        >
          Chat instead
        </div>
      )}
      {storeConfigState.storePlan === "free" && (
        <div className="powered-by-ecoreturn-main">
          <p className="powered-by-text">{`${powered_by}`}</p>
          <div className="powered-by-ecoreturn-content">
            <a
              href="https://saara.io/ecoreturns"
              target="_blank"
              rel="noreferrer"
              className="powered-by-navigate"
            >
              <img
                src="assets/eco_returns_logo.png"
                width="80"
                alt="EcoReturns - Returns management software"
              />
            </a>
          </div>
        </div>
      )}
    </form>
  );
};
